import { get } from "lodash";
import QueryString from "qs";
import { useCallback, useEffect, useState } from "react";
import { api } from "../../utils/InstanceAPI";

const initializePage = {
  currIndex: 1,
};

const useAmazonShopping = firstPageDate => {
  const [list, setList] = useState([]);
  const [page, setPage] = useState(initializePage);
  const [keywords, setKeywords] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async ({ keyword: query, page }) => {
    try {
      setLoading(true);
      return await api
        .get(
          `/be/svc-adapter/purchasing/shop-search${QueryString.stringify({ query, page }, { addQueryPrefix: true })}`
        )
        .then(response => response.json())
        .then(response => response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getList = data => {
    const { querys = [""] } = data || {};
    const [keyword] = querys;
    const { items = [] } = get(data, [keyword], {});
    return { items, keyword };
  };

  const getNewData = async () => {
    const result = await fetchData({
      keyword: keywords,
    });
    const { items } = getList(result);

    setPage(initializePage);
    setList(items);
  };

  const getLoadMoreData = async () => {
    const newPage = page.currIndex + 1;
    const result = await fetchData({
      keyword: keywords,
      page: newPage,
    });
    const { items } = getList(result);

    setPage({ currIndex: newPage });
    setList(list => [...list, ...items]);
  };

  const resetNodeDateState = useCallback(() => {
    const { items, keyword } = getList(firstPageDate);

    setList(items);
    setPage(initializePage);
    setKeywords(keyword);
  }, [firstPageDate]);

  useEffect(() => {
    resetNodeDateState();
  }, [firstPageDate]);

  const noMore = list.length === 0;

  return {
    list,
    loading,
    noMore,
    keywords,
    getNewData,
    getLoadMoreData,
    setKeywords,
  };
};

export default useAmazonShopping;
